module.exports = __webpack_public_path__ + "img/m_1.8c0eee15.jpg";